import React from 'react';
import { ReportGridType, Report } from 'waypoint-types';
import { Dropdown, MenuProps } from 'antd';
import { LeftCircleOutlined, MoreOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { DASH_DASH } from 'config/constants';
import { RouteUrls } from 'routes/RouteConstants';
import { format } from 'date-fns';

const alignStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
};

interface ReportGridHeaderProps {
    reportDataSelected: ReportGridType | undefined;
    cloneReport: (report: Report | undefined) => void;
    isAdmin: boolean;
    data: Report[];
    deleteReports: (
        report: ReportGridType[],
        deletePermanently: boolean
    ) => void;
}

const ReportGridHeader = ({
    reportDataSelected,
    cloneReport,
    isAdmin,
    data,
    deleteReports,
}: ReportGridHeaderProps) => {
    if (!reportDataSelected) {
        return null;
    }

    const items: MenuProps['items'] = [
        {
            key: 'editReport',
            label: (
                <Link
                    style={{
                        textDecoration: 'none',
                    }}
                    to={`${RouteUrls.REPORT_DETAIL}/${reportDataSelected?.id}`}
                >
                    <div>Edit Report</div>
                </Link>
            ),
        },
        {
            key: 'cloneReport',
            label: (
                <div
                    onClick={() =>
                        cloneReport(
                            data.find((r) => r.id === reportDataSelected.id)
                        )
                    }
                >
                    Clone Report
                </div>
            ),
        },
        {
            key: 'deleteReport',
            label: (
                <div
                    onClick={() => {
                        deleteReports([reportDataSelected], false);
                    }}
                >
                    Delete Report
                </div>
            ),
        },
    ];

    return (
        <>
            <div style={{ backgroundColor: 'white', padding: '10px 18px 0px' }}>
                <Link to="/reports/manager">
                    <LeftCircleOutlined style={{ marginRight: 5 }} />
                    Back to Report Manager
                </Link>
            </div>
            <div
                style={{
                    padding: 18,
                    borderBottom: '1px solid #e8e8e8',
                    paddingTop: 12,
                    backgroundColor: 'white',
                }}
            >
                <div
                    style={{
                        ...alignStyle,
                        marginBottom: 12,
                    }}
                >
                    <h1
                        style={{
                            margin: 0,
                            fontSize: '32px',
                            fontWeight: 'bold',
                            maxWidth: '55ch',
                        }}
                    >
                        {reportDataSelected?.report_name ?? ''}
                    </h1>
                    <div style={alignStyle}>
                        <p style={{ margin: '0px 20px 0px 0px' }}>
                            Due Date:{' '}
                            {reportDataSelected?.due_date
                                ? format(
                                      new Date(reportDataSelected?.due_date),
                                      'MMMM d, yyyy'
                                  )
                                : DASH_DASH}
                        </p>

                        {isAdmin ? (
                            <Dropdown
                                placement={'bottomRight'}
                                menu={{
                                    items,
                                }}
                                data-test="report-grid-header-dropdown"
                            >
                                <span
                                    style={{
                                        fontSize: '22px',
                                        fontWeight: 'normal',
                                        textTransform: 'none',
                                        textDecoration: 'underline',
                                        cursor: 'pointer',
                                        marginLeft: '5px',
                                    }}
                                >
                                    <MoreOutlined />
                                </span>
                            </Dropdown>
                        ) : null}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReportGridHeader;
